import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { _GlobalConstants } from '../../../services/globalConstants.service';
import {_UsersService} from "../../../services/users.service";
import {Observable} from "rxjs/Observable";
import {_ReferenceDataService} from "../../../services/referenceData.service";

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;

@Component({
  selector: 'int-allocations-h',
  templateUrl: './int-allocations-h.component.html',
  styleUrls: ['./int-allocations-h.component.css'],
})

export class InternalAllocationsHistory implements OnInit, OnDestroy {

  private subscription: any;
  private users: any;
  private accounts: any;

  constructor (private route: ActivatedRoute, private titleService: Title, private constants: _GlobalConstants, private userService: _UsersService, private referenceData: _ReferenceDataService) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Internal Allocation Event Log");

    this.subscription = Observable.forkJoin(this.userService.getUsers(), this.referenceData.getAccounts()).subscribe((res: Array<any>) => {
      this.users = res[0];
      this.accounts = res[1];
      this.ready();
    });

  }
  ready() {
    var accounts = this.accounts;
    var users = this.users;

    // initialize jqxGrid
    var source = {
      datatype : "json",
      datafields : [{
          name : 'eventTimestamp',
          type : 'date',
          format: 'yyyy-MM-dd HH:mm:ss.fff'
      }, {
          name : 'eventUserId',
          type : 'string'
      }, {
        name: 'eventUserDisplayName',
        type: 'string',
        value: 'eventUserId',
        values: {
          source: users,
          value: 'userId',
          name: 'displayName'
        }
      }, {
          name : 'eventIpAddress',
          type : 'string'
      }, {
          name : 'eventAction',
          type : 'string'
      }, {
    name : 'eventActionDisplayName',
    type : 'string',
    value: 'eventAction',
    values: {
      source: this.constants.getTranslatedValues('resources.internalAllocationEvent.action'),
      value: 'value',
      name: 'display'
    }
    }, {
          name : 'fromAccountId',
          type : 'string'
    }, {
        name: 'fromAccountCode',
        type: 'string',
        value: 'fromAccountId',
        values: {
          source: accounts,
          value: 'accountId',
          name: 'code'
        }
      }, {
          name : 'toAccountId',
          type : 'string'
      }, {
        name: 'toAccountCode',
        type: 'string',
        value: 'toAccountId',
        values: {
          source: accounts,
          value: 'accountId',
          name: 'code'
        }
      }, {
          name : 'purpose',
          type : 'string'
      }, {
    name : 'purposeDisplayName',
    type : 'string',
    value: 'purpose',
    values: {
      source: this.constants.getTranslatedValues('common.staticValues.purpose'),
      value: 'value',
      name: 'display'
    }
  }, {
          name : 'currency',
          type : 'string'
      }, {
          name : 'settlementDate',
          type : 'date',
          format: 'yyyy-MM-dd'
      }, {
          name : 'quantity',
          type : 'string'
      }, {
          name : 'price',
          type : 'string'
      }],
      id : 'eventId',
      url : '/ajax/internal-allocations/events',
      type : 'GET',
      async : true
  };

  var settings = defaultGridViewSettings("#jqxgrid", source);
  settings.columns = [{
      text : 'Timestamp',
      columntype : 'datetimeinput',
      datafield : 'eventTimestamp',
      cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
      width : '160'
  }, {
      text : 'User',
      columntype : 'textbox',
      datafield : 'eventUserDisplayName',
      width : '100'
  }, {
      text : 'IP Address',
      columntype : 'textbox',
      datafield : 'eventIpAddress',
      width : '80'
  },{
      text : 'From Account',
      columntype : 'textbox',
      datafield : 'fromAccountCode',
      width : '120'
  },{
      text : 'To Account',
      columntype : 'textbox',
      datafield : 'toAccountCode',
      width : '120'
  }, {
      text : 'Ccy',
      columntype : 'textbox',
      datafield : 'currency',
      width : '90'
  }, {
      text : 'Quantity',
      columntype : 'textbox',
      datafield : 'quantity',
      width : '100'
  }, {
      text : 'Price',
      columntype : 'textbox',
      datafield : 'price',
      width : '100'
  }, {
      text : 'Purpose',
      columntype : 'textbox',
      datafield : 'purposeDisplayName',
      width : '100'
  }, {
      text : 'Settlement Date',
      columntype : 'datetimeinput',
      datafield : 'settlementDate',
      cellsformat : 'yyyy-MMM-dd',
      width : '80'
  }];

  $("#jqxgrid").jqxGrid(settings);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/int-allocations-h/int-allocations-h.component.ts